import { gql } from "@apollo/client";

export const formsQuery = gql`
query MyQuery (
    $clientsid:uuid
    $id:String
) {
    aatmsv4_smap(order_by: {simformname: asc},  where: {  siminstructorid: {_eq: $id},clientsid: {_eq: $clientsid}, active: {_eq: true}}) {
      simformname
      simform {
        blankform
        presentation
        studymat
      }
    }
  }
`;

export const Register = gql`
query MyQuery($id: String) {
  aatmsv4_register(where: {userid: {_eq: $id}}) {
    fleetsid
    clientsid
  }
}
`